import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class FontSizeService {
  private readonly fontSizeCookieKey = 'sidebarFontSize';
  private fontSizeSubject: BehaviorSubject<number>;
  fontSize$; 

  constructor(private cookieService: CookieService) {
    const savedSize = this.cookieService.get(this.fontSizeCookieKey);
    const initialSize = savedSize ? +savedSize : 14;

    this.fontSizeSubject = new BehaviorSubject<number>(initialSize);
    this.fontSize$ = this.fontSizeSubject.asObservable();

    this.applyFontSize(initialSize);

    this.fontSize$.subscribe(size => {
      this.applyFontSize(size);
    });
  }

  private updateFontSize(size: number) {
    if (size < 10) size = 10;
    if (size > 24) size = 24;

    this.fontSizeSubject.next(size);
    this.cookieService.set(this.fontSizeCookieKey, size.toString(), 30, '/');   // every page, not only the one it was changed on
  }

  private applyFontSize(size: number) {
    document.documentElement.style.setProperty('--app-font-size', `${size}px`);
  }

  increase() {
    this.updateFontSize(this.fontSizeSubject.value + 1);
  }

  decrease() {
    this.updateFontSize(this.fontSizeSubject.value - 1);
  }

  reset() {
    this.updateFontSize(14); 
  }
}
